// src/ga.js
import ReactGA from 'react-ga4';

export const initGA = () => {
    ReactGA.initialize(process.env.REACT_APP_GA4_MEASUREMENT_ID, {
    gaOptions: {
      anonymizeIp: true, // Anonymize IP addresses
      storage: 'none', // Disable cookies and local storage
      clientId: 'non_cookie_identifier', // Set a static client ID
    },
   // testMode: process.env.REACT_APP_ENV === 'dev', // Enable test mode in development
  });
};

export const trackPageView = (page) => {
  ReactGA.send({ hitType: 'pageview', page });
};
